export default __webpack_public_path__ + "static/media/vg.d972e8fb.svg";